import { isSignedDocument } from '@trustvc/w3c-vc';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const type = "DOCUMENT_STATUS";
const name = "W3CEmptyCredentialStatus";
const w3cEmptyCredentialStatus = {
  skip: /* @__PURE__ */ __name(async () => {
    return {
      type,
      name,
      reason: {
        code: 0,
        codeString: "SKIPPED",
        message: `Document contains a credentialStatus.`
      },
      status: "SKIPPED"
    };
  }, "skip"),
  test: /* @__PURE__ */ __name((document) => {
    const doc = document;
    return !!doc.credentialStatus === false || Array.isArray(doc.credentialStatus) && doc.credentialStatus.length === 0 || Object.keys(doc.credentialStatus)?.length === 0;
  }, "test"),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  verify: /* @__PURE__ */ __name(async (document, verifierOptions) => {
    const doc = document;
    const verificationResult = isSignedDocument(doc);
    if (verificationResult) {
      return {
        type,
        name,
        data: true,
        status: "VALID"
      };
    } else {
      return {
        type,
        name,
        data: false,
        reason: {
          message: "Document is not a valid SignedVerifiableCredential"
        },
        status: "INVALID"
      };
    }
  }, "verify")
};

export { w3cEmptyCredentialStatus };
